import { call, put, takeLatest } from 'redux-saga/effects';
import { authApiClient } from '../client/axios';
import { fetchUserFailure, fetchUserRequest, fetchUserSuccess } from './userSlice';

function* fetchUser(action) {
  try {
    const response = yield call(authApiClient.get, `/me`);
    yield put(fetchUserSuccess(response.data));
  } catch (error) {
    yield put(fetchUserFailure(error.response?.data?.errors?.message || 'Login failed'));
  }
}

export default function* userSaga() {
  yield takeLatest(fetchUserRequest.type, fetchUser);
}
